const TOKEN_KEY = 'jwt_token';
const USER_KEY = 'user';
const EXPIRATION_KEY = 'token_expiration';

export const saveSession = (token, userData, expirationDate) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    localStorage.setItem(EXPIRATION_KEY, String(expirationDate));
};

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY) || null;
};

export const getUser = () => {
    const user = localStorage.getItem(USER_KEY);
    if (!user) return null;
    try {
        return JSON.parse(user);
    } catch {
        return null;
    }
};

export const isSessionValid = () => {
    const token = getToken();
    const expiration = localStorage.getItem(EXPIRATION_KEY);
    if (!token || !expiration) return false;
    return Number(expiration) > Date.now();
};

export const clearSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(EXPIRATION_KEY);
};
